import _ from 'lodash'

function addMetadataAliases(metadata) {
	metadata['slides'] = metadata.briefings.slides
	metadata['strategy-maps'] = metadata.strategyMaps
	_.forEach(metadata, function(value, key) {
		if (key != 'scorecards') {
			// e.g. document instead of documents
			var singular = key.substring(0, key.length-1)
			metadata[singular] = value
		}
	})
	metadata['scorecard-item'] = metadata.scorecards
	metadata['scoring-type'] = metadata.scoringTypes
}

export default addMetadataAliases

addMetadataAliases.__filename__ = 'components/metadata-aliases.js'
